import { createUseStyles } from 'react-jss';

import { PricingAppTheme } from '~app/styles/pricing/types';
import { StyleProps } from './types';

const useEnterprisePageStyles = createUseStyles<string, StyleProps, PricingAppTheme>(({ pricingPalette, spacing }) => ({
  ContactList: {
    lineHeight: '1.8',
    listStyleType: 'none',
    textAlign: 'center',
    marginTop: spacing[1],
  },
  FeatureItem: {
    fontSize: '16px',
    textAlign: 'left',
    lineHeight: '32px',
    '&:before': {
      content: '"•"',
      marginLeft: '-35px',
      marginRight: spacing[3],
      paddingRight: spacing[4],
      color: pricingPalette.colors.sabaeus,
    },
  },
  ListHeading: {
    fontSize: '16px',
    textAlign: 'left',
    marginTop: '5px',
    lineHeight: '32px',
    maxWidth: '350px',
  },
  TypographyBolded: {
    fontSize: '32px',
    fontWeight: '500',
    margin: '16px 0',
    color: pricingPalette.colors.charcoal,
  },
  HubSpotWrapper: {
    background: pricingPalette.colors.canvas,
  },
}));

export default useEnterprisePageStyles;
